import { SVGProps } from 'react';

const YoutubeIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M23.7609 7.19688C23.7609 7.19688 23.5266 5.54219 22.8047 4.81563C21.8906 3.85938 20.8688 3.85469 20.4 3.79844C17.0438 3.55469 12.0047 3.55469 12.0047 3.55469H11.9953C11.9953 3.55469 6.95625 3.55469 3.6 3.79844C3.13125 3.85469 2.10938 3.85938 1.19531 4.81563C0.473438 5.54219 0.24375 7.19688 0.24375 7.19688C0.24375 7.19688 0 9.14219 0 11.0828V12.9016C0 14.8422 0.239062 16.7875 0.239062 16.7875C0.239062 16.7875 0.473437 18.4422 1.19062 19.1688C2.10469 20.125 3.30469 20.0922 3.83906 20.1953C5.76094 20.3781 12 20.4344 12 20.4344C12 20.4344 17.0438 20.425 20.4 20.1859C20.8688 20.1297 21.8906 20.125 22.8047 19.1688C23.5266 18.4422 23.7609 16.7875 23.7609 16.7875C23.7609 16.7875 24 14.8469 24 12.9016V11.0828C24 9.14219 23.7609 7.19688 23.7609 7.19688ZM9.52031 15.1094V8.36406L16.0031 11.7484L9.52031 15.1094Z"
      fill="white"
    />
  </svg>
);

export default YoutubeIcon;
